import React from "react";

const ClassificationFeedbackCapabilityNotice = ({ message, isError = false }) => (
  <div
    className={`lineitem-ai-capability-notice${
      isError ? " lineitem-ai-capability-notice--error" : ""
    }`}
    role={isError ? "alert" : "status"}
    aria-live={isError ? "assertive" : "polite"}
    tabIndex={-1}
    data-feedback-error={isError}
  >
    {message}
  </div>
);

export default ClassificationFeedbackCapabilityNotice;
